import { axios } from '@/plugins/axios-pol'

export default {
  namespaced: true,

  state: {
    cups: [],
    cup: null,
  },

  getters: {
    getCups: (state) => state.cups,
    getCup: (state) => state.cup,
  },

  mutations: {
    SET_CUPS(state, cups) {
      state.cups = cups
    },
    SET_CUP(state, cup) {
      state.cup = cup
    },
  },

  actions: {
    async fetchCupsById({ commit }, idPersonal) {
      try {
        const response = await axios.get(`/personal/api/EstadoFuerza/personal/${idPersonal}/histCupsPersonales`)
        commit('SET_CUPS', response.data.data)
      } catch (error) {
        console.error(error)
      }
    },

    async fetchCupById({ commit }, { idPersonal, idHistCup }) {
      try {
        const response = await axios.get(
          `/personal/api/EstadoFuerza/personal/${idPersonal}/histCupsPersonales/${idHistCup}`
        )
        commit('SET_CUP', response.data.data)
      } catch (error) {
        console.error(error)
      }
    },

    async createCup({ dispatch }, { idPersonal, payload }) {
      try {
        await axios.post(`/personal/api/EstadoFuerza/personal/${idPersonal}/histCupsPersonales`, payload, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        dispatch('fetchCupsById', idPersonal)
      } catch (error) {
        console.error('Error al crear el CUP:', error)
      }
    },

    async updateCup({ dispatch }, { idPersonal, idHistCup, payload }) {
      try {
        await axios.put(`/personal/api/EstadoFuerza/personal/${idPersonal}/histCupsPersonales/${idHistCup}`, payload, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        dispatch('fetchCupsById', idPersonal)
      } catch (error) {
        console.error('Error al actualizar el CUP:', error)
      }
    },

    async deleteCup({ dispatch }, { idPersonal, idHistCup }) {
      await axios.put(`/personal/api/EstadoFuerza/personal/${idPersonal}/histCupsPersonales/${idHistCup}/delete`)
      dispatch('fetchCupsById', idPersonal)
    },
  },
}
